import { useEffect, useRef, useState } from "react";

function Stars() {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    for (let i = 0; i < 80; i++) {
      const s = document.createElement("div");
      const z = Math.random() * 1.5 + 0.3;
      s.className = "star";
      s.style.cssText = `width:${z}px;height:${z}px;top:${Math.random() * 80}%;left:${Math.random() * 100}%;--d:${2 + Math.random() * 5}s;--dl:${Math.random() * 7}s;--op:${0.07 + Math.random() * 0.35};`;
      c.appendChild(s);
    }
    return () => {
      c.innerHTML = "";
    };
  }, []);
  return <div ref={ref} className="absolute inset-0" />;
}

function BoardRow({
  code,
  sub,
  dest,
  destSub,
  gateClass,
  gateLabel,
  isLive,
  flipItems,
}) {
  const dotColor = gateClass.includes("gold")
    ? "bg-gold blink-dot"
    : gateClass.includes("dim")
      ? "bg-t-dim"
      : "bg-mint";

  return (
    <div
      className={[
        "grid items-center border-b border-[#0E2A47] py-[clamp(8px,1.1vh,12px)] px-[15px]",
        isLive ? "bg-[rgba(109,211,167,.05)] border-r-2 border-r-mint" : "",
      ].join(" ")}
      style={{ gridTemplateColumns: "24% 48% 28%" }}
    >
      <span className="text-[.72rem] font-semibold text-t-sec leading-[1.3]">
        {code}
        <small className="block text-[.58rem] text-t-dim mt-px">{sub}</small>
      </span>

      <span>
        {flipItems ? (
          <>
            <div className="flip">
              <div className="ftrack">
                {flipItems.map((item, i) => (
                  <span key={i}>{item}</span>
                ))}
              </div>
            </div>
            <span className="block text-[.58rem] text-t-dim mt-px">
              {destSub}
            </span>
          </>
        ) : (
          <>
            <span className="block text-[.77rem] font-bold text-t-primary">
              {dest}
            </span>
            <span className="block text-[.58rem] text-t-dim mt-px">
              {destSub}
            </span>
          </>
        )}
      </span>

      <span
        className={`flex items-center gap-1 text-[.58rem] font-extrabold tracking-widest uppercase ${gateClass}`}
      >
        <span
          className={`w-[5px] h-[5px] rounded-full flex-shrink-0 ${dotColor}`}
        />
        {gateLabel}
      </span>
    </div>
  );
}

export default function Hero() {
  const [clock, setClock] = useState("--:--");

  useEffect(() => {
    const tick = () => {
      const n = new Date();
      setClock(
        String(n.getHours()).padStart(2, "0") +
          ":" +
          String(n.getMinutes()).padStart(2, "0"),
      );
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ paddingTop: "var(--nav-h)" }}
    >
      {/* Background */}
      <div
        className="absolute inset-0 pointer-events-none z-0 overflow-hidden"
        aria-hidden="true"
      >
        <Stars />
        <div className="d-mark">◆</div>
        <div className="f-arc" />
        <div
          className="absolute bottom-[26%] left-0 right-0 h-px opacity-[.28] blur-[.5px]"
          style={{
            background:
              "linear-gradient(90deg,transparent,#6DD3A7 30%,#F2B949 50%,#6DD3A7 70%,transparent)",
          }}
        />
        <svg
          className="runway"
          viewBox="0 0 860 300"
          fill="none"
          preserveAspectRatio="xMidYMax meet"
        >
          <line
            x1="430"
            y1="0"
            x2="0"
            y2="300"
            stroke="#6DD3A7"
            strokeWidth=".7"
          />
          <line
            x1="430"
            y1="0"
            x2="860"
            y2="300"
            stroke="#6DD3A7"
            strokeWidth=".7"
          />
          {[
            ["430", "8", "430", "35"],
            ["430", "50", "430", "77"],
            ["430", "92", "430", "119"],
            ["430", "134", "430", "165"],
            ["430", "182", "430", "220"],
            ["430", "238", "430", "285"],
          ].map(([x1, y1, x2, y2], i) => (
            <line
              key={i}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="#F2B949"
              strokeWidth="1.1"
            />
          ))}
          {[
            ["375", "38"],
            ["310", "78"],
            ["228", "128"],
            ["128", "188"],
            ["18", "255"],
            ["485", "38"],
            ["550", "78"],
            ["632", "128"],
            ["732", "188"],
            ["842", "255"],
          ].map(([cx, cy], i) => (
            <circle key={i} cx={cx} cy={cy} r="2.2" fill="#F2B949" />
          ))}
          <ellipse
            cx="430"
            cy="6"
            rx="110"
            ry="10"
            fill="#6DD3A7"
            opacity=".45"
          />
        </svg>
      </div>

      {/* Hero Body */}
      <div className="relative z-10 flex-1 grid grid-cols-1 lg:grid-cols-2 items-center gap-[clamp(16px,3vw,48px)] px-[clamp(16px,5vw,60px)] py-[clamp(24px,5vh,64px)]">
        {/* Text */}
        <div className="lg:pl-[clamp(0px,.8vw,12px)]">
          <div
            className="anim-up inline-flex items-center gap-1.5 border border-[rgba(109,211,167,0.25)] rounded-full px-3 py-1 mb-[clamp(12px,1.4rem,22px)]"
            style={{ animationDelay: ".06s" }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-mint pill-dot" />
            <span className="text-[clamp(.68rem,.9vw,.8rem)] font-medium text-mint">
              برنامج وتان للتدريب التقني · الدمام
            </span>
          </div>

          <h1
            className="anim-up font-cairo font-black leading-[1.08] text-t-primary mb-2 tracking-tight"
            style={{
              fontSize: "clamp(2rem,3.8vw,4rem)",
              animationDelay: ".15s",
            }}
          >
            كل رحلة
            <br />
            تبدأ <em className="not-italic text-mint">بخطوة.</em>
          </h1>

          <p
            className="anim-up font-cairo font-bold text-gold leading-[1.2] mb-[clamp(14px,1.4rem,24px)]"
            style={{
              fontSize: "clamp(1.15rem,2.1vw,2.1rem)",
              animationDelay: ".24s",
            }}
          >
            خطوتك التقنية تبدأ هنا.
          </p>

          <p
            className="anim-up leading-[1.95] text-t-sec max-w-[450px] mb-[clamp(16px,1.8rem,28px)]"
            style={{
              fontSize: "clamp(.88rem,.95vw,.97rem)",
              animationDelay: ".31s",
            }}
          >
            آفاق مو مجرد برنامج تدريبي.
            <br />
            هي رحلتك من اللي تحلم فيه إلى اللي تقدر تبنيه فعلاً.
            <br />
            <strong className="text-t-primary">
              تختار وجهتك، ونرافقك في كل محطة
            </strong>{" "}
            — حتى تخرج بخبرة حقيقية وملف مهني يتكلم عنك.
          </p>

          <div
            className="anim-up flex items-center gap-2.5 flex-wrap mb-[clamp(16px,1.8rem,28px)]"
            style={{ animationDelay: ".39s" }}
          >
            <a
              href="https://store.afaaqwetaan.com"
              className="font-cairo font-bold bg-gold text-ink px-[26px] py-3 rounded-[4px] no-underline inline-flex items-center gap-1.5 whitespace-nowrap transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5 hover:shadow-[0_10px_28px_rgba(242,185,73,.24)]"
              style={{ fontSize: "clamp(.86rem,.92vw,.96rem)" }}
              target="_blank"
              rel="noopener"
            >
              <svg
                className="w-[15px] h-[15px] flex-shrink-0"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                aria-hidden="true"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
              اكتشف رحلتك
            </a>
            <a
              href="#community"
              className="font-cairo font-medium border border-[rgba(247,242,233,.18)] text-t-sec px-5 py-3 rounded-[4px] no-underline whitespace-nowrap transition-all duration-200 hover:border-[rgba(247,242,233,.38)] hover:text-t-primary"
              style={{ fontSize: "clamp(.84rem,.9vw,.92rem)" }}
            >
              انضم للمجتمع مجاناً
            </a>
          </div>

          <div
            className="anim-up flex items-center gap-3.5 flex-wrap"
            style={{ animationDelay: ".47s" }}
          >
            {["تقسيط عبر تمارا", "تدريب عن بُعد", "شهادة إتمام معتمدة"].map(
              (item, i) => (
                <span
                  key={item}
                  className="flex items-center gap-1.5 text-t-dim"
                  style={{ fontSize: "clamp(.7rem,.76rem,.78rem)" }}
                >
                  {i > 0 && <span className="w-px h-3 bg-t-dim" />}
                  <span className="w-[15px] h-[15px] rounded-full border border-mint flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-[7px] h-[7px] stroke-mint"
                      viewBox="0 0 10 8"
                      fill="none"
                    >
                      <polyline points="1 4 3.5 6.5 9 1" strokeWidth="1.8" />
                    </svg>
                  </span>
                  {item}
                </span>
              ),
            )}
          </div>
        </div>

        {/* Departure Board */}
        <div
          className="anim-rt flex flex-col items-center gap-3"
          style={{ direction: "ltr", animationDelay: ".18s" }}
        >
          <div className="flex items-center gap-2 text-[.6rem] tracking-[.17em] text-t-dim uppercase font-semibold w-full max-w-[460px]">
            <span className="flex-1 h-px bg-[rgba(109,211,167,.1)]" />
            <span>◆ لوحة المغادرات · Afaaq Departures ◆</span>
            <span className="flex-1 h-px bg-[rgba(109,211,167,.1)]" />
          </div>

          <div className="w-full max-w-[460px]">
            <div
              className="w-full bg-ink-deep border border-[rgba(109,211,167,.14)] rounded-[14px] overflow-hidden shadow-[0_0_60px_rgba(8,24,40,.9)]"
              role="region"
              aria-label="لوحة برامج آفاق"
            >
              {/* Board header */}
              <div className="flex items-center justify-between px-[15px] py-[9px] bg-[#040C16] border-b border-[rgba(109,211,167,.08)]">
                <div className="flex items-center gap-2">
                  <span className="text-[.54rem] tracking-[.1em] text-t-dim uppercase border-l border-[rgba(109,211,167,.12)] pl-2">
                    AFAAQ ◆ وتان
                  </span>
                  <span className="text-[.68rem] font-bold text-mint tracking-[.05em]">
                    AFQ
                  </span>
                </div>
                <span className="text-[.7rem] font-semibold text-gold tracking-[.08em]">
                  {clock}
                </span>
              </div>

              {/* Column headers */}
              <div
                className="grid border-b border-[rgba(109,211,167,.06)] bg-[#050D18] px-[15px] py-1"
                style={{ gridTemplateColumns: "24% 48% 28%" }}
              >
                {["الرحلة", "الوجهة", "البوابة"].map((h) => (
                  <span
                    key={h}
                    className="text-[.54rem] tracking-[.12em] uppercase text-t-dim font-semibold"
                  >
                    {h}
                  </span>
                ))}
              </div>

              <BoardRow
                code="AFQ"
                sub="صيف ٢٦"
                flipItems={[
                  "الذكاء الاصطناعي",
                  "الأمن السيبراني",
                  "تحليل البيانات",
                  "مواطن القوة",
                  "الذكاء الاصطناعي",
                ]}
                destSub="مسار مكثّف · ١٠ أسابيع"
                gateClass="text-gold"
                gateLabel="BOARD"
                isLive
              />
              <BoardRow
                code="BCM"
                sub="٣–٤ أيام"
                dest="المعسكرات"
                destSub="Power BI · Python · AI · SQL"
                gateClass="text-mint"
                gateLabel="OPEN"
              />
              <BoardRow
                code="REC"
                sub="دائماً"
                dest="الدورات المسجّلة"
                destSub="في أي وقت · بوتيرتك"
                gateClass="text-mint opacity-65"
                gateLabel="24/7"
              />
              <BoardRow
                code="WRK"
                sub="٩٠ د"
                dest="الورش التفاعلية"
                destSub="مهارة — عمق حقيقي"
                gateClass="text-t-dim"
                gateLabel="SOON"
              />
              <BoardRow
                code="STR"
                sub="٣–٤ أيام"
                dest="باقة مواطن القوة"
                destSub="Gallup ◆ كوتش CIPD"
                gateClass="text-mint"
                gateLabel="OPEN"
              />

              {/* Ticker */}
              <div className="flex items-center bg-[#030A12] border-t border-[rgba(109,211,167,.08)] overflow-hidden h-[26px]">
                <span className="text-[.53rem] tracking-[.14em] text-gold uppercase font-extrabold whitespace-nowrap px-3 h-full flex items-center border-r border-[rgba(109,211,167,.1)] flex-shrink-0">
                  ◆ AFQ
                </span>
                <span className="tscroll">
                  آفاق توصلك للآفاق &ensp;◆&ensp; تقييم ٩.٢٥/١٠ &ensp;◆&ensp;
                  +٤٠٠ ساعة تدريب &ensp;◆&ensp; +٢٠ متدرب خريج &ensp;◆&ensp;
                  تقسيط عبر تمارا &ensp;◆&ensp; مجتمع آفاق مفتوح للجميع
                </span>
              </div>
            </div>
          </div>

          <p
            className="text-[.66rem] text-t-dim flex items-center gap-1.5 w-full max-w-[460px]"
            style={{ direction: "rtl" }}
          >
            <span className="text-[.5rem] text-mint">◆</span>
            جميع الرحلات عن بُعد · متاح من أي مكان
          </p>
        </div>

        {/* Scroll hint */}
        <div className="shint" aria-hidden="true">
          <span>اكتشف أكثر</span>
          <svg
            className="w-4 h-4 stroke-current fill-none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>

      {/* Stats */}
      <div
        className="anim-stats relative z-10 flex-shrink-0 grid grid-cols-2 sm:grid-cols-5 border-t border-[rgba(109,211,167,.09)]"
        role="list"
        aria-label="أرقام آفاق"
      >
        {[
          { n: "9.25", l: "تقييم المتدربين\nمن ١٠" },
          { n: "+400", l: "ساعة تدريبية\nفي كل مسار" },
          { n: "+20", l: "متدرب\nخريج" },
          { n: "+10", l: "خبير من\nسوق العمل" },
          { n: "8", l: "مشاريع تخرج\nحقيقية" },
        ].map(({ n, l }, i) => (
          <div
            key={n}
            role="listitem"
            className={[
              "sc bg-ink-mid text-center transition-colors duration-200 hover:bg-[#0D2440]",
              "py-[clamp(14px,2vh,22px)] px-4",
              i === 0 ? "" : "border-r border-[rgba(109,211,167,.06)]",
              i === 4
                ? "col-span-2 sm:col-span-1 border-t sm:border-t-0 border-[rgba(109,211,167,.07)]"
                : "",
            ].join(" ")}
          >
            <span
              className="font-cairo font-black text-mint leading-none block mb-1"
              style={{ fontSize: "clamp(1.4rem,2.2vw,1.75rem)" }}
            >
              {n}
            </span>
            <span
              className="text-t-sec whitespace-pre-line"
              style={{
                fontSize: "clamp(.62rem,.72rem,.74rem)",
                lineHeight: 1.4,
              }}
            >
              {l}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
